import * as Styled from './styled'
import { MusicSearchSection } from './search'
import { MUSIC_TAB_CONTENT_TABBAR_DATA, MY_MUSIC } from './data'
import FlatTabbar from 'common-components/FlatTabbar'
import { useCallback, useContext } from 'react'
import { MusicLibrary } from './music-library'
import { MyMusic } from './my-music'
import { AudioContentContext } from '../context'

interface IProps {
  activeGenreName: string
  setActiveGenreName: React.Dispatch<React.SetStateAction<string>>
}

export const MusicTabContent: React.FC<IProps> = ({
  activeGenreName,
  setActiveGenreName
}) => {
  const { isShowMusicSearchView, musicActiveTabName, setMusicActiveTabName } =
    useContext(AudioContentContext)

  const isMyMusic = musicActiveTabName === MY_MUSIC

  const onCloseActiveGenreView = useCallback(() => {
    setActiveGenreName('')
  }, [setActiveGenreName])

  const setActiveGenreNameCallback = useCallback(
    (name: string) => {
      setActiveGenreName(name)
    },
    [setActiveGenreName]
  )

  return (
    <Styled.MusicTabContentWrapper $isRemoveTopPadding={!!activeGenreName}>
      {!activeGenreName && <MusicSearchSection />}

      {!isShowMusicSearchView && (
        <>
          {!activeGenreName && (
            <Styled.TabbarWrapper>
              <FlatTabbar
                dataWithTexts={MUSIC_TAB_CONTENT_TABBAR_DATA}
                defaultActiveTabName={musicActiveTabName}
                onCurrentItemClick={setMusicActiveTabName}
              />
            </Styled.TabbarWrapper>
          )}

          {isMyMusic ? (
            <MyMusic />
          ) : (
            <MusicLibrary
              activeGenreName={activeGenreName}
              onCloseActiveGenreView={onCloseActiveGenreView}
              setActiveGenreNameCallback={setActiveGenreNameCallback}
            />
          )}
        </>
      )}
    </Styled.MusicTabContentWrapper>
  )
}
